import { ClientFulfillmentGroupFolder } from "@redotech/redo-model/views/folders";
import { ClientFulfillmentGroupView } from "@redotech/redo-model/views/views";
import { z } from "zod";

export const getViewsAndFolders = {
  input: z.object({ merchantTimezone: z.string().nullish() }),
  output: z.object({
    folders: z.array(ClientFulfillmentGroupFolder),
    views: z.array(ClientFulfillmentGroupView),
  }),
};
